import { typographyStyle, Colors, Flex } from '@revenuemarket/cds';
import { theme } from '@revenuemarket/design';
import { Condition } from '@revenuemarket/react';
import { Tooltip, Typography } from 'antd';

import { AbstractBankAccount } from './AGGridBankAccountRenderer';
import { ORGANIZATION_CODES, ShortedBankName } from '../../models';
import { getOrganizationLogo } from '../../utils';

interface Props {
  data?: AbstractBankAccount;
  hideDescription?: boolean;
}

const ShortedBankAccountInfoCell = ({ data, hideDescription }: Props) => {
  if (data == null) {
    return null;
  }

  return (
    <Tooltip
      title={data.displayAccountNumber ?? data.accountNumber}
      align={{ points: ['cl', 'cr'] }}
    >
      <Flex gap={6} align="center">
        <img
          width={16}
          height={16}
          src={getOrganizationLogo(data.bankCode).x1}
          alt={ORGANIZATION_CODES[data.bankCode]}
        />
        <Condition
          expression={Boolean(data.accountAlias)}
          then={() => (
            <Flex direction="column" style={{ minWidth: 0 }}>
              <Typography.Text
                ellipsis
                style={{
                  ...typographyStyle['13_400'],
                  color: Colors.gray800,
                }}
              >
                {data.accountAlias}
              </Typography.Text>
              {hideDescription ? (
                <div />
              ) : (
                <Typography.Text
                  ellipsis
                  style={{
                    ...typographyStyle['12_400'],
                    color: Colors.gray500,
                  }}
                  color={theme.colorTokens.textDescription}
                >
                  {ShortedBankName[data.bankCode]}&nbsp;
                  {data.accountNumber.slice(-4)}
                </Typography.Text>
              )}
            </Flex>
          )}
          else={() => (
            <Flex direction="column" style={{ minWidth: 0 }}>
              <Typography.Text
                ellipsis
                style={{
                  ...typographyStyle['13_400'],
                  color: Colors.gray800,
                }}
              >
                {ShortedBankName[data.bankCode]}&nbsp;
                {data.accountNumber.slice(-4)}
              </Typography.Text>
              <Typography.Text
                ellipsis
                style={{
                  ...typographyStyle['12_400'],
                  color: Colors.gray500,
                }}
                color={theme.colorTokens.textDescription}
              >
                {data.accountAlias}
              </Typography.Text>
            </Flex>
          )}
        />
      </Flex>
    </Tooltip>
  );
};

export default ShortedBankAccountInfoCell;
